import React from 'react';
import { FeaturePageLayout } from '../components/FeaturePageLayout';
import { Fingerprint, BookOpen, MessageCircle, Sliders, Globe, UserCheck } from 'lucide-react';
/*
  SEO SPECIFICATION:
  Title: MISTR Persona Builder — AI Trained on Your Business Voice | MindStream.ing
  Meta Desc: 3 conversations and MISTR knows your brand voice, your clients, your history. Every output sounds like you — not generic AI. Your persona. Your MISTR.
  Primary KW: AI brand voice training
*/
export function PersonaBuilder() {
  return <FeaturePageLayout seoTitle="MISTR Persona Builder — AI Trained on Your Business Voice | MindStream.ing" seoDesc="3 conversations and MR knows your brand voice, your clients, your history. Every output sounds like you — not generic AI. Your persona. Your MR." heroEyebrow="PERSONA BUILDER" heroTitle={<>
          MISTR. Trained to Sound{' '}
          <span className="text-gradient" data-id="element-1922">Like You.</span>
        </>} heroDesc="3 conversations and MR knows your brand voice, your clients, your history. Every output sounds like you — not generic AI." heroImage="https://cdn.magicpatterns.com/uploads/dWXrt9xNFh6bNpGwsjysP6/ChatGPT_Image_Mar_20,_2026,_02_15_39_PM.png" howItWorks={{
    title: 'How It Works',
    steps: [{
      title: 'Talk to MR',
      desc: 'Have 3 natural conversations with MR about your business.'
    }, {
      title: 'MR Learns',
      desc: 'MR builds your complete persona profile and vocabulary.'
    }, {
      title: 'Perfect Match',
      desc: 'Every output matches your voice perfectly across all channels.'
    }]
  }} features={{
    cards: [{
      icon: <Fingerprint size={24} data-id="element-1923" />,
      title: 'Brand Voice Training',
      desc: 'Analyzes your past emails and content to learn your exact communication style.'
    }, {
      icon: <BookOpen size={24} data-id="element-1924" />,
      title: 'Client History Ingestion',
      desc: 'Absorbs the context of your relationships so it never sounds like a stranger.'
    }, {
      icon: <UserCheck size={24} data-id="element-1925" />,
      title: 'Communication Style Matching',
      desc: 'Knows when to be formal, when to use emojis, and when to be direct.'
    }, {
      icon: <Sliders size={24} data-id="element-1926" />,
      title: 'Tone Calibration',
      desc: 'Adjusts tone dynamically based on the situation (e.g., sales vs. support).'
    }, {
      icon: <Globe size={24} data-id="element-1927" />,
      title: 'Multilingual Persona',
      desc: 'Maintains your unique personality even when translating to other languages.'
    }]
  }} data-id="element-1921" />;
}